import HeaderNotices from "../Settings/HeaderNotices";
import LicenseInactiveNotice from "./LicenseInactiveNotice";

const SettingPage = ({
  title,
  children,
  headerButton,
  subContainer,
  headerClassName,
  headerChildren,
  headerJustification = "justify-between",
}) => {
  const Header = () => {
    return (
      <>
        {window.sby_settings.isLicenseInactive &&
        window.sby_settings.sbyIsPro ? (
          <LicenseInactiveNotice />
        ) : null}
        <div
          className={`section-header flex flex-row ${headerJustification} align-baseline ${
            headerClassName ? headerClassName : ""
          }`}
        >
          <h1 className="pr-5">{title}</h1>
          {headerButton}
          {headerChildren}
        </div>
      </>
    );
  };

  const Container = () => {
    if (subContainer) {
      return (
        <div className="sby-sb-container sby-no-margin">
          <Header />
          {children}
        </div>
      );
    }

    return (
      <>
        <Header />
        {children}
      </>
    );
  };
  return (
    <div className="sby-fb-full-wrapper sby-fb-fs">
      <HeaderNotices />
      <Container />
    </div>
  );
};

export default SettingPage;
